import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import type { SavingsBadgeProps } from './types';

import styles from './styles.module.scss';

export const SavingsBadge = ({ amount }: SavingsBadgeProps): React.ReactElement => {
  const intl = useIntl();

  return (
    <div
      className={styles.wrapper}
      role="status"
      aria-label={intl.formatMessage({ id: 'certificates.saveUpToAria' }, { amount })}
    >
      <div className={styles.badge}>
        <span className={styles.label}>
          <FormattedMessage id="certificates.saveUpTo" values={{ amount }} />
        </span>
      </div>
      <div className={styles.tail} aria-hidden />
    </div>
  );
};
